export default import.meta.ROLLUP_FILE_URL_SmGIj4KWbdLY65jCk1z2ng